import React, {memo, useState} from "react";
import {useTranslation} from "react-i18next";
import debounce from "lodash/debounce";
//local
import SubHeading from "components/SubHeading";
import CustomRadioSwitch from "components/CustomRadioSwitch";
import {IconLink} from "components/icons";
import {Input} from "components/Input";

const ContractTemplateLinkSettings = memo(({settings, onUpdate}) => {
  const {t} = useTranslation();

  const [contractPreparationCustomLink, setContractPreparationCustomLink] = useState(
    settings?.contractPreparationCustomLink
  );
  const [isContractPreparationCustomLink, setIsContractPreparationCustomLink] = useState(
    !!settings?.contractPreparationCustomLink
  );
  const [isValidUrl, setIsValidUrl] = useState(true);

  const validateUrl = (url) => {
    if (!url) return true; // Empty string is valid
    return /^https?:\/\/.+/.test(url);
  };

  const handleChangeContractPreparationCustomLink = (e) => {
    const link = e.target.value;
    setContractPreparationCustomLink(link);
    const isValid = validateUrl(link);
    setIsValidUrl(isValid);
    if (isValid) {
      debounce(() => {
        onUpdate({contractPreparationCustomLink: link});
      }, 1000)();
    }
  };

  return (
    <div className="organization-settings__department-labels mb-12">
      <SubHeading title="LINK_TO_CONTRACT_TEMPLATE" icon={<IconLink />} />
      <CustomRadioSwitch
        checked={isContractPreparationCustomLink}
        mediumText
        label={t("SHOW_A_LINK_TO_CONTRACT_TEMPLATE")}
        small
        addWrapperClass="mt-4"
        informationText="SHOW_A_LINK_TO_CONTRACT_TEMPLATE_TOOLTIP"
        isActive={(checked) => {
          setIsContractPreparationCustomLink(checked);
          if (!checked) {
            handleChangeContractPreparationCustomLink({target: {value: ""}});
          }
        }}
      />
      <div className="df-column mt-4">
        {isContractPreparationCustomLink && (
          <>
            <Input
              placeholder={t("LINK_TO_CONTRACT_TEMPLATE_PLACEHOLDER")}
              small
              fullWidth
              name="contractPreparationCustomLink"
              value={contractPreparationCustomLink}
              width="400px"
              disabled={!isContractPreparationCustomLink}
              className={`input mr-4 ${!isValidUrl ? "error" : ""}`}
              onChange={handleChangeContractPreparationCustomLink}
            />
            {!isValidUrl && (
              <div className="mt-2 red" style={{fontSize: "12px"}}>
                {t("INVALID_URL_FORMAT")} {t("INVALID_URL_FORMAT_SUFFIX")}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
});

export default ContractTemplateLinkSettings;
